<div (click)='onClick()' [@openClose]="isOpen? 'open' : 'closed'" (@openClose.start)="onAnimationEvent($event)"
     (@openClose.done)="onAnimationEvent($event)" class="civ-toaster">
  <sfc-notification [ngClass]="{'position-center': centered}" (onDismiss)="onDismissListener()"
                     type="{{messageType}}" [attr.dismissible]="hasCloseButton || null">
    <div>{{messageContent}}</div>
  </sfc-notification>
</div>
